// extracted by mini-css-extract-plugin
export default {"container":"RemoveDataConfirmationModal_container__TsCXF","right":"RemoveDataConfirmationModal_right__eHdZs","footer":"RemoveDataConfirmationModal_footer__U1EMX"};